import React from 'react'
import UploadIcon from 'assets/svgr-icons/Upload.svg'
import MyFilesIcon from 'assets/svgr-icons/My_Files.svg'
import AiCharactersIcon from 'assets/svgr-icons/AI_Characters.svg'
import RemoveIcon from 'assets/svgr-icons/Remove.svg'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IFlyoutMenuItem } from 'common-components/ActionsFlyout/types'

interface IUploadedImageActions {
  handleUploadClick: () => void
  onMyFilesClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  onAiCharactersClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
  handleRemoveImage: (e?: React.MouseEvent<SVGSVGElement>) => void
}

export const getUploadedImageActions = ({
  handleUploadClick,
  onMyFilesClick,
  onAiCharactersClick,
  handleRemoveImage
}: IUploadedImageActions): IFlyoutMenuItem[] => [
  {
    key: T.UPLOAD_LABEL,
    title: translate(T.UPLOAD_LABEL_SIDEBAR),
    icon: React.createElement(UploadIcon),
    onClick: handleUploadClick
  },
  {
    key: T.MY_FILES_LABEL,
    title: translate(T.MY_FILES_LABEL),
    icon: React.createElement(MyFilesIcon),
    onClick: () => onMyFilesClick({} as React.MouseEvent<HTMLButtonElement>)
  },
  {
    key: T.AI_CHARACTERS_LABEL,
    title: translate(T.AI_CHARACTERS_LABEL),
    icon: React.createElement(AiCharactersIcon),
    onClick: () => onAiCharactersClick()
  },
  {
    key: T.DELETE_LABEL,
    title: translate(T.DELETE_LABEL),
    icon: React.createElement(RemoveIcon),
    onClick: () => handleRemoveImage()
  }
]
